import { getCountries } from "country-state-picker"
import i18n from "@/plugins/i18n"

// Country names in the app language come from the browser's built-in CLDR data (Intl.DisplayNames),
// so no language file has to carry ~230 names. The English name from country-state-picker stays the
// stored/filter value everywhere; only the text shown to the user changes.
// English, a language the browser has no data for, or an older browser keep the English name.

const regionNamesByLocale = {}

const regionNames = (locale) => {
  if (!(locale in regionNamesByLocale)) {
    let names = null
    try {
      if (locale !== "en" && Intl.DisplayNames && Intl.DisplayNames.supportedLocalesOf([locale]).length) {
        names = new Intl.DisplayNames([locale], { type: "region", fallback: "none" })
      }
    } catch (e) {
      names = null
    }
    regionNamesByLocale[locale] = names
  }
  return regionNamesByLocale[locale]
}

const countryLabel = (country, locale) => {
  const names = regionNames(locale)
  if (!names || !country.code) return country.name
  try {
    return names.of(country.code.toUpperCase()) || country.name
  } catch (e) {
    return country.name
  }
}

// country-state-picker list plus `label` (name in the app language), sorted by that label.
export const getLocalizedCountries = (locale = i18n.locale || "en") => {
  const countries = getCountries().map((country) => ({ ...country, label: countryLabel(country, locale) }))
  if (locale === "en") return countries
  return countries.sort((a, b) => a.label.localeCompare(b.label, locale))
}

let countriesByName = null

// For a stored English name such as "Brazil" -> "Brasil" in pt. Unknown names are returned as they are.
export const localizeCountryName = (name, locale = i18n.locale || "en") => {
  if (!name || locale === "en") return name
  if (!countriesByName) countriesByName = new Map(getCountries().map((country) => [country.name, country]))
  const country = countriesByName.get(name)
  return country ? countryLabel(country, locale) : name
}
